import { FC } from 'react'
import { Checkbox } from 'antd'
import PerFlexRow from '../../../../../components/custom_components/FlexRow'
import PerText from '../../../../../components/custom_components/Text'

interface LabeledCheckboxProps {
  name: string
  label: string
  checked: boolean
  hasError?: boolean
  onChange: (name: string, value: boolean) => void
}

const LabeledCheckbox: FC<LabeledCheckboxProps> = ({ name, label, checked, hasError, onChange }) => {
  return (
    <label>
      <PerFlexRow direction="row" mt="xxs">
        <Checkbox name={name} checked={checked} onChange={(e) => onChange(name, e.target.checked)} data-e2e-label-checkbox />
        <PerText ml="xs" color={hasError ? 'error' : 'default'}>
          {label}
        </PerText>
      </PerFlexRow>
    </label>
  )
}
export { LabeledCheckbox }
